"use strict";

var cx = require("classnames");
var UserAvatar = require("app/shared/components/User/user-avatar");

var ActivityOwner = React.createClass({
  render: function(){
    var entityOwnerEmail = null;
    var classes = cx(
      "activity-user",
      this.props.className,
      "d-f align-center minw-0"
    );

    if (this.props.dropbox) {
      entityOwnerEmail = this.props.dropbox.from;
    }

    var avatarURL = (this.props.createdBy.avatar) ? this.props.createdBy.avatar["70x70"] : null;

    return (this.props.createdBy.type=="User")?(
      <div className={classes}>
        <UserAvatar className="activity-userAvatar mr-10" name={this.props.createdBy.name} avatarURL={avatarURL}/>
        <div className="minw-0">
          <div className="activity-userName fs-14 truncate-sentence">{this.props.createdBy.name}</div>
          {this.props.children}
        </div>
      </div>
    ):(
      <div className={classes}>
        <div className="activity-typeIcon custom-glyphicon icon-person"></div>
        <div className="minw-0">
          <span className="pr-5">De:</span><label className="fs-14 tt-upper m-0">{this.props.createdBy.name}</label>
          <span className="ml-5 c-lightGrey">{entityOwnerEmail}</span>
          <div>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
});

module.exports = ActivityOwner;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityInput/activity-owner.jsx